import '@orobix/label-studio/build/static/css/main.css'

import LabelStudio, {
  LSConfig,
  LSInterfaces,
  LSTask,
  LSUser,
} from '@orobix/label-studio'
import React, { useEffect } from 'react'

import useStyles from './Annotator.styles'

interface LabelStudioAnnotatorProps {
  config: LSConfig
  interfaces: LSInterfaces
  user: LSUser
  task?: LSTask
  labelStudioRef: React.MutableRefObject<LabelStudio | null>
}

/**
 * Create the label studio instance and mount the Label Studio app on
 * the given DOM element.
 */
export const LabelStudioAnnotator = ({
  labelStudioRef,
  task,
  config,
  interfaces,
  user,
}: LabelStudioAnnotatorProps) => {
  const classes = useStyles()

  useEffect(
    () => {
      if (!task || !config) return undefined

      // eslint-disable-next-line no-new
      new LabelStudio('label-studio', {
        config,
        interfaces,
        user,
        task,

        onLabelStudioLoad: (instance: LabelStudio) => {
          // eslint-disable-next-line no-param-reassign
          labelStudioRef.current = instance
          instance.assignConfig(config)
          instance.assignTask(task)

          const store = instance.annotationStore
          const obj = store.addAnnotation({ userGenerate: true })
          store.selectAnnotation(obj.id)
          if (task.annotations.length > 0) {
            task.annotations.forEach((annotation) => {
              obj.deserializeResults(annotation.result)
            })
          }
        },
      })
      return () => {
        try {
          // eslint-disable-next-line no-param-reassign
          labelStudioRef.current = null
          LabelStudio.destroyAll()
        } catch (e) {
          // do nothing
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config, task?.id, task?.annotations.length]
  )

  return <div id="label-studio" className={classes.labelStudio} />
}
